import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { messages } from './messages';
import { CostReviewLineItemWithRecommendation } from '../cost-review-line-item-with-recommendation/cost-review-line-item-with-recommendation';

import type { CostReviewRateShopperRecommendation, ShippingServiceCostReview } from '../../../prop-types/cost-review.types';

type CostReviewLineItemRateShopperWithRecommendationProps = {
  isRecommendationSelected: boolean;
  onToggleRecommendation: (recommendationKey: string) => void;
  isToggleRecommendationDisabled: boolean;
  originalService: ShippingServiceCostReview;
  rateShopperRecommendation: CostReviewRateShopperRecommendation;
};

export const CostReviewLineItemRateShopperWithRecommendation = ({
  isRecommendationSelected,
  onToggleRecommendation,
  originalService,
  rateShopperRecommendation,
  isToggleRecommendationDisabled,
}: CostReviewLineItemRateShopperWithRecommendationProps) => {
  const intl = useIntl();

  const recommendation = useMemo(
    () => ({
      key: rateShopperRecommendation.key,
      totalSavings: rateShopperRecommendation.totalSavings,
      name: intl.formatMessage(messages.rateShopper),
      serviceCollectionGuid: rateShopperRecommendation.toServiceCollectionGuid,
    }),
    [intl, rateShopperRecommendation.key, rateShopperRecommendation.totalSavings, rateShopperRecommendation.toServiceCollectionGuid],
  );

  return (
    <CostReviewLineItemWithRecommendation
      isRecommendationSelected={isRecommendationSelected}
      isToggleRecommendationDisabled={isToggleRecommendationDisabled}
      onToggleRecommendation={onToggleRecommendation}
      originalServiceCost={originalService.subTotal}
      originalServiceName={originalService.serviceName}
      recommendation={recommendation}
    />
  );
};
